'use strict';

module.exports = Backbone.Model.extend({
    defaults: {
        value: '',
        validationStatus: 'init',
    },
    setValue(value, options = {validate: true}) {
        const attrs = Odigeo._.extend({}, this.toJSON(), {
            value,
        });
        this.setAttrs(attrs, options);
    },
    setAttrs(attrs, options) {
        const validationStatus = this.validate(attrs) || 'valid';
        const validation = options.validate ? {validationStatus} : {};
        this.set(Odigeo._.extend(attrs, validation), Odigeo._.extend(options, {
            validate: false,
        }));
    },
    checkValid() {
        const isValid = this.validate() || 'valid';
        const previousValid = this.get('validationStatus');
        this.set({validationStatus: isValid}, {silent: true});
        this.triggerChangeToTrackSubmit(isValid, previousValid);
    },
    triggerChangeToTrackSubmit(isValid, previousValid) {
        if (isValid !== 'valid') {
            this.trigger('change:validationStatus', this, isValid, true);
        }
    },
    save(pageData) {
        pageData[this.name] = this.get('value');
    },
    fetch(pageData) {
        this.setValue(pageData[this.name]);
        this.trigger('fetch');
    },
});
